import server from '@/request/encryptRequest';

// 查询商机推送记录
export const getBizOppSendRecordPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/tenantBizOppWechatMsgSendRecord/getBizOppSendRecordPageList', data);
};

// 导出商机推送记录
export const exportTenantBizOppWechatMsgSendRecord = (data) => {
  return server.post('/xiaozi-saas/wireless/tenantBizOppWechatMsgSendRecord/exportTenantBizOppWechatMsgSendRecord', data, {
    responseType: 'blob',
  });
};

// 查询用户推送记录统计
export const getTenantSendRecordStatisticPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/tenantBizOppWechatMsgSendRecord/getTenantSendRecordStatisticPageList', data);
};

// 查询租户商机订阅数量
export const getBizOppSubTenantCount = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubTenant/count', data);
};

// 查询租户商机订阅详情
export const getBizOppSubTenantDetail = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubTenant/detail', data);
};

// 导出租户商机订阅列表
export const exportBizOppSubTenantDetail = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubTenant/export', data, {
    responseType: 'blob',
  });
};

// 查询租户商机订阅列表
export const getBizOppSubTenantPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubTenant/pageList', data);
};

// 查询xmo动态日志分页列表
export const getBizOppSubTenantDynamicPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/dynamicInformation/xmo/pageList', data);
};

// 查询商机推送记录
export const bizOppSendRecordPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/wechatMsgSendRecord/bizOppSendRecordPageList', data);
};
